import { jsx, jsxs } from "react/jsx-runtime";
import { Box, IconMessage, Text, Inline } from "braid-design-system";
import clsx from "clsx";
import { useEmployerHeaderContext } from "../../../EmployerFooter/EmployerFooter.mjs";
import { useChatContext, getWindowPathWithoutLanguage } from "../../EmployerHeader.mjs";
import { root, headerLink, navItem, touchableNavItem, desktopNavItem, isActive } from "./ChatHeaderLink.css.mjs";
const chatPath = "/chat";
const analyticsDesktopEvent = {
  eventName: "navigation_pressed",
  actionOrigin: "global header",
  actionPressed: "header - chat"
};
const analyticsMobileEvent = {
  eventName: "navigation_pressed",
  actionOrigin: "mobile header",
  actionPressed: "header - chat"
};
const handleClick = (props, analyticsEvent, handleInteractionTracking) => (_event) => {
  if (analyticsEvent) {
    handleInteractionTracking(analyticsEvent);
  }
};
const isChatPage = () => getWindowPathWithoutLanguage().includes("/chat") || getWindowPathWithoutLanguage().includes("on-chat-page");
const MessageCount = (props) => /* @__PURE__ */ jsx(
  Box,
  {
    background: "brandAccent",
    borderRadius: "full",
    position: "absolute",
    style: {
      padding: "4px",
      top: "10px",
      left: "15px"
    },
    children: /* @__PURE__ */ jsx(Text, { size: "xsmall", children: props.unreadMessageCount })
  }
);
const ChatHeaderDesktopLink = ({
  linkRenderer: LinkRenderer,
  urlResolver,
  ...props
}) => {
  const headerItemLinkClasses = [
    root,
    headerLink,
    navItem,
    touchableNavItem,
    desktopNavItem,
    isChatPage() ? isActive : ""
  ];
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const { chatUser } = useChatContext();
  const linkProps = { ...props, className: clsx(headerItemLinkClasses) };
  const trackingEvent = {
    ...analyticsDesktopEvent,
    chatNotificationCount: chatUser ? chatUser.unreadMessageCount : 0
  };
  return chatUser && /* @__PURE__ */ jsx(
    LinkRenderer,
    {
      ...linkProps,
      href: urlResolver({ path: chatPath }),
      onClick: handleClick(props, trackingEvent, handleInteractionTracking),
      children: /* @__PURE__ */ jsxs(
        Box,
        {
          position: "relative",
          userSelect: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          paddingY: "small",
          paddingX: "none",
          marginX: "none",
          children: [
            /* @__PURE__ */ jsx(Box, { marginRight: "xxsmall", children: /* @__PURE__ */ jsx(IconMessage, { size: "large" }) }),
            chatUser.unreadMessageCount > 0 && !isChatPage() && /* @__PURE__ */ jsx(MessageCount, { unreadMessageCount: chatUser.unreadMessageCount }),
            /* @__PURE__ */ jsx(Text, { size: "small", children: "Chats" })
          ]
        }
      )
    }
  );
};
const ChatHeaderMobileLink = ({
  linkRenderer: LinkRenderer,
  urlResolver,
  ...props
}) => {
  const headerItemLinkClasses = [
    headerLink,
    navItem,
    touchableNavItem
  ];
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const linkProps = {
    ...props,
    href: urlResolver({ path: chatPath }),
    className: clsx(headerItemLinkClasses)
  };
  const { chatUser } = useChatContext();
  const trackingEvent = {
    ...analyticsMobileEvent,
    chatNotificationCount: chatUser ? chatUser.unreadMessageCount : 0
  };
  return chatUser && /* @__PURE__ */ jsx(
    LinkRenderer,
    {
      ...linkProps,
      onClick: handleClick(props, trackingEvent, handleInteractionTracking),
      children: /* @__PURE__ */ jsx(Inline, { space: "xsmall", children: /* @__PURE__ */ jsxs(
        Box,
        {
          position: "relative",
          userSelect: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          padding: "small",
          marginLeft: "none",
          paddingLeft: "none",
          children: [
            /* @__PURE__ */ jsx(Box, { marginRight: "xxsmall", children: /* @__PURE__ */ jsx(IconMessage, { size: "large" }) }),
            chatUser.unreadMessageCount > 0 && !isChatPage() && /* @__PURE__ */ jsx(MessageCount, { unreadMessageCount: chatUser.unreadMessageCount }),
            /* @__PURE__ */ jsx(Text, { weight: isChatPage() ? "strong" : "regular", size: "small", children: "Chats" })
          ]
        }
      ) })
    }
  );
};
const ChatHeaderMobileUnreadCount = () => {
  const { chatUser } = useChatContext();
  return chatUser && chatUser.unreadMessageCount > 0 && /* @__PURE__ */ jsx(
    Box,
    {
      background: "brandAccent",
      borderRadius: "full",
      marginRight: "none",
      style: {
        padding: "4px"
      },
      children: /* @__PURE__ */ jsx(Text, { size: "xsmall", children: chatUser.unreadMessageCount })
    }
  );
};
export {
  ChatHeaderDesktopLink,
  ChatHeaderMobileLink,
  ChatHeaderMobileUnreadCount
};
